export default {
	lockScroll(scrollPosition = 0, isIOSMobileDevice = false) {
		const body = document.querySelector('body')

		if (!isIOSMobileDevice) {
			body.style.overflow = 'hidden'
			return
		}

		body.style.setProperty('top', `-${scrollPosition}px`)

		body.classList.add('lock-scroll')
	},

	getBodyScrollPosition() {
		return window.scrollY || document.documentElement.scrollTop
	},

	unlockScroll(scrollPosition = 0, isIOSMobileDevice = false) {
		const body = document.querySelector('body')

		if (!isIOSMobileDevice) {
			body.style.overflow = 'visible'
			return
		}

		body.classList.remove('lock-scroll')

		body.style.removeProperty('top')

		window.scrollTo(0, scrollPosition)
	}
}
